import { h, Component } from "preact";
import { Link } from "preact-router/match";
import style from "./style";
import { logout } from "../authstore";

import dashboardIconSrc from "assets/svg/header/dashboard.svg";
import wizardIconSrc from "assets/svg/header/wizard.svg";
import logoutIconSrc from "assets/svg/header/logout.svg";

export default class Header extends Component {
  handleLogoutClick = e => {
    e.preventDefault(), logout(this.props.gender);
  };

  
  render({ check, gender, showHeader }) {
    if (showHeader) {
      return (
        <header
          class={`${style.Header} ${gender === "women" ? style.women : null}`}
        >
          {check ? (
            <nav class={style.Nav}>
              <Link
                class={style.NavItem}
                activeClassName={style.active}
                href={`/${gender}/dash`}
              >
                <img src={dashboardIconSrc} class={style.NavItemIcon} />
                <span class={style.NavItemLabel}>Dashboard</span>
              </Link>
              <Link
                class={style.NavItem}
                activeClassName={style.active}
                href={`/${gender}/wizard/1`}
              >
                <img src={wizardIconSrc} class={style.NavItemIcon} />
                <span class={style.NavItemLabel}>Neuer Plan</span>
              </Link>
              <Link
                class={style.NavItem}
                activeClassName={style.active}
                href={`/${gender}`}
                onClick={this.handleLogoutClick}
              >
                <img src={logoutIconSrc} class={style.NavItemIcon} />
                <span class={style.NavItemLabel}>Logout</span>
              </Link>
            </nav>
          ) : (
            <nav class={style.Nav}>
              <Link
                class={style.NavItem}
                activeClassName={style.active}
                href={`/${gender}/`}
              >
                <img src={dashboardIconSrc} class={style.NavItemIcon} />
                <span class={style.NavItemLabel}>Home</span>
              </Link>
            </nav>
          )}
        </header>
      );
    }

  }
}



// WEBPACK FOOTER //
// ./components/header/index.js